export default {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    base_url : 'http://127.0.0.1:8000',
    registerUser: [],
    loginUser: [],
    countries: [],
    currencies: [],
    factories: [],
    factory_products: [],
    sku: [],
    currency_skus: [],
    factory_skus: [],
    token: localStorage.getItem('token') || '',
    steps: [],
    selected_steps: [],
    categories: [],
    default_categories: [],
    errors: [],
    roles:[],
    users:[],
    showLoader: false,
    total_pages: 0,
    files: [],
    user_files:[],
    permission_modules:[],
    parent_labels:[],
    permissions:[],
    navigation:[],
    role_permissions:[],
    series: [],
    customers:[],
    customers_with_current_product_assigned:[],
    translations:[]
}